import axios from 'axios';
import { handleShellSessionExpiry } from '@/shells/services/sessionExpiry';

export class ExercisesHttpError extends Error {
  constructor(message, status = null, code = 'REQUEST_FAILED') {
    super(message);
    this.name = 'ExercisesHttpError';
    this.status = status;
    this.code = code;
  }
}

const client = axios.create({
  baseURL: process.env.VUE_APP_API || '',
  timeout: 30000,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
});

client.interceptors.request.use(config => {
  const token = localStorage.getItem('user_access_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  response => response,
  error => {
    const status = error && error.response && error.response.status;
    handleShellSessionExpiry(status);
    const payload = error && error.response && error.response.data;
    const message = payload && payload.message
      ? payload.message
      : 'No se pudo completar la solicitud de ejercicios.';
    return Promise.reject(new ExercisesHttpError(message, status, payload && payload.error));
  }
);

export default client;
